export default {
  SET_LOADING(state, payload) {
    state.isLoading = payload;
  },
};
